import { render, staticRenderFns } from "./ReturnsAllowance.vue?vue&type=template&id=2792c5de"
import script from "./ReturnsAllowance.vue?vue&type=script&lang=js"
export * from "./ReturnsAllowance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports